export default {
  STORE_USER_AGENT: 'STORE_USER_AGENT',
  STORE_BIXBY_FLAG: 'STORE_BIXBY_FLAG',
};
